// extracted by mini-css-extract-plugin
var _1 = "GridItemModal_block__8f235";
var _2 = "GridItemModal_blockWrapper__15a79";
var _3 = "GridItemModal_date__57e77";
var _4 = "GridItemModal_divider__3fc91";
var _5 = "GridItemModal_item__74a3e";
var _6 = "GridItemModal_name__f7f28";
var _7 = "GridItemModal_title__3e750";
export { _1 as "block", _2 as "blockWrapper", _3 as "date", _4 as "divider", _5 as "item", _6 as "name", _7 as "title" }
